<template>
    <transition
        enter-active-class="transition-opacity duration-300 ease-out"
        leave-active-class="transition-opacity duration-300 ease-in"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
    >

    <div v-if="open" class="fixed relative  z-50 " aria-labelledby="modal-title" role="dialog" aria-modal="true">

        <div class="fixed inset-0 bg-modal transition-opacity" aria-hidden="true"></div>

        <div class="fixed  inset-0 z-50 w-screen overflow-y-auto ease-out duration-300">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

                <div class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                    <div class="absolute right-0 top-0 pr-4 pt-4 sm:block">
                        <button
                            type="button"
                            class="rounded-md text-black h-6 w-6 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            aria-label="Close"
                            v-on:click="close"
                        >
                            <svg
                                class="size-12"
                                fill="black"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                aria-hidden="true"
                                data-slot="icon"
                            >
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
                            </svg>
                        </button>
                    </div>
                    <div>
                        <div class="mt-10 text-center sm:ml-4 sm:mt-0 sm:text-left">
                            <div class="mt-2">
                                <template v-for="(desc,index) in descriptions" v-if="showDescription(desc)">
                                    <description-view
                                        :field="field"
                                        :description="desc"
                                        :descriptionsTotal="descriptionsTotal"
                                    />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                        <button
                            type="button"
                            class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-red-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            v-on:click="close"
                        >Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    </transition>
    <!--    <div class="hidden md:flex flex-row flex-wrap">-->
    <!--        <template v-for="(desc,index) in descriptions" v-if="showDescription(desc)">-->
    <!--            <description-view :field="field" :description="desc" :descriptionsTotal="descriptionsTotal"/>-->
    <!--        </template>-->
    <!--    </div>-->
</template>
<script>

import DescriptionView from "./DescriptionView";
import DescriptionScrollView from "./DescriptionScrollView";
//<div class="flex flex-row flex-wrap overflow-y-hidden overflow-x-auto">
export default {
    name: 'ModalFiledOptionsDescriptions',
    components: { DescriptionScrollView, DescriptionView },
    props: {
        field: {},
        show: false,
    },
    data: function () {
        return {
            open: this.show,
        }
    },
    computed: {
        descriptions() {
            return this.field.options.map(item => item.description).filter(item => this.showDescription(item));
        },
        descriptionsTotal() {
            return this.descriptions.length;
        }
    },
    watch: {
        // Sync `open` when `show` changes
        show(newVal) {
            this.open = newVal;
        }
    },
    methods: {
        close() {
            this.open = false
            this.$emit("close-modal");

        },
        showDescription(desc) {
            return !!desc.text || !!desc.header
        }
    }
}
</script>